'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var classNames = require('classnames');
var card = require('@andes/card');
var Close24 = require('@andes/icons/Close24');
var context = require('@andes/context');
var isWebviewIOSOs = require('@andes/common/build/utils/isWebviewIOS');
var FeedbackNegative40 = require('@andes/icons/FeedbackNegative40');
var FeedbackPositive40 = require('@andes/icons/FeedbackPositive40');
var FeedbackCaution40 = require('@andes/icons/FeedbackCaution40');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var Close24__default = /*#__PURE__*/_interopDefaultLegacy(Close24);
var isWebviewIOSOs__default = /*#__PURE__*/_interopDefaultLegacy(isWebviewIOSOs);
var FeedbackNegative40__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackNegative40);
var FeedbackPositive40__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackPositive40);
var FeedbackCaution40__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackCaution40);
var module$3 = "@andes/feedback-screen";
var locale$2 = "en-US";
var translations$2 = {
  "andes-feedback-screen\u0004cerrar": [null, "Close"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/feedback-screen";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-feedback-screen\u0004cerrar": [null, "Cerrar"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/feedback-screen";
var locale = "pt-BR";
var translations = {
  "andes-feedback-screen\u0004cerrar": [null, "Fechar"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
const namespace$3 = 'andes-feedback-screen';
var _FeedbackNegative, _FeedbackCaution, _FeedbackPositive, _FeedbackPositive2;
const namespace$2 = 'andes-feedback-screen__icon';
const FeedbackIcon = _ref => {
  let {
    color = 'green'
  } = _ref;
  const iconClassNames = classNames__default["default"](namespace$2, "".concat(namespace$2, "--").concat(color));
  const FEEDBACK_ICON_OPTIONS = {
    red: _FeedbackNegative || (_FeedbackNegative = /*#__PURE__*/_jsx__default["default"](FeedbackNegative40__default["default"], {})),
    orange: _FeedbackCaution || (_FeedbackCaution = /*#__PURE__*/_jsx__default["default"](FeedbackCaution40__default["default"], {})),
    green: _FeedbackPositive || (_FeedbackPositive = /*#__PURE__*/_jsx__default["default"](FeedbackPositive40__default["default"], {}))
  };
  const selectedIcon = color ? FEEDBACK_ICON_OPTIONS[color] : undefined;
  return /*#__PURE__*/_jsx__default["default"]("div", {
    "aria-hidden": true,
    className: iconClassNames
  }, void 0, selectedIcon || _FeedbackPositive2 || (_FeedbackPositive2 = /*#__PURE__*/_jsx__default["default"](FeedbackPositive40__default["default"], {})));
};
FeedbackIcon.displayName = 'FeedbackIcon';
var FeedbackIcon$1 = FeedbackIcon;
const namespace$1 = 'andes-feedback-screen__header';
const FeedbackHeader = _ref => {
  let {
    asset,
    className,
    color = 'green',
    description,
    highlightedValue,
    overline,
    title,
    type
  } = _ref;
  const componentAsset = (asset === null || asset === void 0 ? void 0 : asset.element) || asset;
  const isThumbnail = (asset === null || asset === void 0 ? void 0 : asset.type) === 'thumbnail' || Boolean(componentAsset);
  const isIllustration = (asset === null || asset === void 0 ? void 0 : asset.type) === 'illustration' && type === 'simple';
  const headerClassNames = classNames__default["default"](namespace$1, {
    ["".concat(namespace$1, "--with-illustration")]: isIllustration
  }, className);
  return /*#__PURE__*/_jsx__default["default"]("div", {
    className: headerClassNames
  }, void 0, /*#__PURE__*/React__default["default"].isValidElement(componentAsset) && (isIllustration || isThumbnail) ? /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace$1, "-asset")
  }, void 0, componentAsset) : /*#__PURE__*/_jsx__default["default"](FeedbackIcon$1, {
    color: color
  }), /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace$1, "-info")
  }, void 0, overline && /*#__PURE__*/_jsx__default["default"]("p", {
    className: "".concat(namespace$1, "-overline")
  }, void 0, overline), /*#__PURE__*/_jsx__default["default"]("h2", {
    className: "".concat(namespace$1, "-title")
  }, void 0, title), highlightedValue && /*#__PURE__*/_jsx__default["default"]("p", {
    className: "".concat(namespace$1, "-highlighted ").concat(namespace$1, "-highlighted--").concat(color)
  }, void 0, highlightedValue), description && /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace$1, "-description")
  }, void 0, description)));
};
FeedbackHeader.displayName = 'FeedbackHeader';
var FeedbackHeader$1 = FeedbackHeader;
var _Close;
const FeedbackScreen = /*#__PURE__*/function () {
  const FeedbackScreen = /*#__PURE__*/React.forwardRef((props, ref) => {
    var _div;
    const {
      id,
      className,
      children,
      actions,
      header,
      onExit,
      type = 'simple',
      onClose
    } = props;
    const componentId = context.useId(id);
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const {
      device
    } = React.useContext(context.AndesContext);
    const isWebviewIOS = isWebviewIOSOs__default["default"](device);
    const hasBody = React__default["default"].Children.count(children) > 0;
    const feedbackScreenClassNames = classNames__default["default"](namespace$3, className, {
      ["".concat(namespace$3, "--no-body")]: !hasBody,
      ["".concat(namespace$3, "--body")]: !!hasBody,
      ["".concat(namespace$3, "-congrats")]: type === 'congrats',
      ["".concat(namespace$3, "--webview-ios")]: isWebviewIOS
    });
    const actionsClassNames = classNames__default["default"]("".concat(namespace$3, "__actions"), {
      ["".concat(namespace$3, "__actions-header")]: !hasBody,
      ["".concat(namespace$3, "__actions-body")]: hasBody
    });
    const cardClassNames = classNames__default["default"]("".concat(namespace$3, "__header-card"));
    const getCardStructure = () => {
      const headerComponent = /*#__PURE__*/React__default["default"].createElement(FeedbackHeader$1, _extends__default["default"]({}, header, {
        type: type
      }));
      return /*#__PURE__*/_jsx__default["default"](card.Card, {
        id: "".concat(componentId, "-").concat(namespace$3, "-card"),
        className: cardClassNames
      }, void 0, /*#__PURE__*/_jsx__default["default"](card.CardContent, {}, void 0, headerComponent, !hasBody && actions && (_div || (_div = /*#__PURE__*/_jsx__default["default"]("div", {
        className: actionsClassNames
      }, void 0, actions)))));
    };
    return /*#__PURE__*/React__default["default"].createElement("div", {
      ref: ref,
      className: feedbackScreenClassNames
    }, (onExit || onClose) && /*#__PURE__*/_jsx__default["default"]("button", {
      id: "".concat(componentId, "-close"),
      className: "".concat(namespace$3, "__close"),
      onClick: onExit || onClose,
      onKeyDown: e => e.preventDefault(),
      tabIndex: 0,
      "aria-label": i18n.pgettext(namespace$3, 'cerrar'),
      type: "button"
    }, void 0, _Close || (_Close = /*#__PURE__*/_jsx__default["default"](Close24__default["default"], {}))), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace$3, "__wrapper")
    }, void 0, getCardStructure(), children), actions && hasBody && /*#__PURE__*/_jsx__default["default"]("div", {
      className: actionsClassNames
    }, void 0, actions));
  });
  FeedbackScreen.displayName = 'FeedbackScreen';
  return FeedbackScreen;
}();
var FeedbackScreen$1 = FeedbackScreen;
const namespace = 'andes-feedback-screen__content';
const FeedbackContent = _ref => {
  let {
    children,
    className
  } = _ref;
  const contentClassNames = classNames__default["default"](namespace, className);
  return /*#__PURE__*/_jsx__default["default"]("div", {
    className: contentClassNames
  }, void 0, children);
};
FeedbackContent.displayName = 'FeedbackContent';
var FeedbackContent$1 = FeedbackContent;
exports.FeedbackContent = FeedbackContent$1;
exports.FeedbackScreen = FeedbackScreen$1;
exports["default"] = FeedbackScreen$1;
